var map = {
	"./IBM_logo.svg.png": 101,
	"./Kaggle_logo.webp": 102,
	"./LOGO-UIPATH-850.png": 103,
	"./coursera-01.png": 104,
	"./crew_ai_logo.png": 105,
	"./datacamp-01.png": 106,
	"./hacker_rank_logo.webp": 107,
	"./hackerbank_logo.png": 108,
	"./hackerbank_logo_new.png": 109,
	"./hf-logo.png": 110,
	"./iitg-01.png": 111,
	"./iitg.png": 112,
	"./ineuron-01.png": 113,
	"./problem-01.png": 114,
	"./python-01.png": 115,
	"./simplilearn-01.png": 116,
	"./tabana-01.png": 117,
	"./tabcon-01.png": 118,
	"./udemy-01.png": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;